module.exports = __webpack_public_path__ + "static/media/logonew.deaf19a3.png";